import React, { Fragment, Component } from 'react';
import { camelCase, startCase } from 'lodash';
import classNames from 'classnames';
import PropTypes from 'prop-types';

class GroupButton extends Component {
  handleChange(key, isItemsSelected) {
    const {
      items = [],
      onItemsChanged = () => { },
      onCheckItem = () => { },
      onUncheckItem = () => { }
    } = this.props;

    items[key] = !isItemsSelected;
    onItemsChanged(items);
    if (items[key]) onCheckItem(key); else onUncheckItem(key, items);
  }

  render() {
    const { t, items, isDisabled = false } = this.props;

    return (
      <Fragment>
        <div className="btn-group mr-2 d-block" role="group">
          {
            items ? Object.keys(items).map((key) => {
              const isItemsSelected = items[key];
              const btnClass = classNames('btn', 'btn-outline-secondary',
                { 'btn-preset-selected': isItemsSelected });
              return (
                <button
                  type="button"
                  className={btnClass}
                  key={key}
                  disabled={isDisabled}
                  onClick={() => this.handleChange(key, isItemsSelected)}
                >
                  {t(camelCase(`button${startCase(key)}`))}
                </button>
              );
            }) : ''
          }
        </div>
      </Fragment>
    );
  }
}

GroupButton.propTypes = {
  items: PropTypes.shape(),
  onItemsChanged: PropTypes.func,
  onCheckItem: PropTypes.func,
  onUncheckItem: PropTypes.func,
};

export default GroupButton;
